export default function AboutHero() {
  return (
    <section className="w-full border-b border-background-200 bg-background-100 px-4 py-12 md:px-8 md:py-16">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:items-center">
        <div className="lg:col-span-7">
          <span className="inline-flex items-center gap-1.5 rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs font-semibold text-primary-700">
            <i className="ri-fire-line text-sm"></i>
            关于瓜田热评
          </span>
          <h1 className="mt-5 font-heading text-3xl font-black leading-tight tracking-tight text-foreground-950 md:text-5xl">
            我们相信，最有意思的内容
            <span className="text-primary-600">藏在评论区</span>
          </h1>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-foreground-600 md:text-lg">
            瓜田热评是一个专注于「热门吃瓜 + 网友热评」的内容整理平台。我们不生产瓜，我们只做一件事：
            把热门事件里网友的精彩发言、犀利吐槽和高赞神回复挑出来，摆在你面前，让你看事件、看评论、也看态度。
          </p>
        </div>

        <div className="lg:col-span-5">
          <div className="rounded-lg border border-background-200 bg-background-50 p-6">
            <h2 className="font-heading text-base font-bold text-foreground-950">我们的网站定位</h2>
            <ul className="mt-4 flex flex-col gap-4 text-sm leading-relaxed text-foreground-700">
              <li className="flex gap-3">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className="ri-eye-line text-base"></i>
                </span>
                <span>
                  <strong className="font-semibold text-foreground-950">围观现场</strong>
                  ：用最少的字把事件讲清楚，不渲染、不带节奏。
                </span>
              </li>
              <li className="flex gap-3">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                  <i className="ri-chat-quote-line text-base"></i>
                </span>
                <span>
                  <strong className="font-semibold text-foreground-950">热评精选</strong>
                  ：把评论区最有价值的观点整理出来，省去你翻上千条的成本。
                </span>
              </li>
              <li className="flex gap-3">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                  <i className="ri-heart-3-line text-base"></i>
                </span>
                <span>
                  <strong className="font-semibold text-foreground-950">温柔底色</strong>
                  ：热闹之外，我们也愿意多留一些让人觉得世界还不错的故事。
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}